import { render, staticRenderFns } from "./comAutocomplete.vue?vue&type=template&id=2dc91c3b&scoped=true&"
import script from "./comAutocomplete.vue?vue&type=script&lang=js&"
export * from "./comAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc91c3b",
  null
  
)

export default component.exports